//LOGO
export const LOGO = '/assets/images/logo.png'

//SITE NAME
export const SITE_NAME = 'The Chicago Wine Company'

// SIDE PANEL LIST
export const SIDE_PANEL = [
    {
        label: 'Dashboard',
        path: '/dashboard',
        type: 'single',
    },
    {
        label: 'Sync Dashboard',
        path: '/syncdashboard',
        type: 'single',
    },
    {
        label: 'Auctions',
        path: 'auction',
        type: 'multiple',
        subLinks: [
            {
                label: 'Active',
                path: '/auction/open',
            },
            {
                label: 'Upcoming',
                path: '/auction/upcomming',
            },
            {
                label: 'Draft',
                path: '/auction/draft',
            },
            {
                label: 'Past',
                path: '/auction/closed',
            },
        ],
    },
    {
        label: 'Listing',
        type: 'multiple',
        path: 'listing',
        subLinks: [
            {
                label: 'Active',
                path: '/listing/open',
            },
            {
                label: 'Sold',
                path: '/listing/sold',
            },
            {
                label: 'Unsold',
                path: '/listing/unsold',
            },
            {
                label: 'Draft',
                path: '/listing/draft',
            },
            // {
            //     label: 'Relisted',
            //     path: '/listing/relisted',
            // },
            {
                label: 'Post or Update',
                path: '/listing/add_update',
            },
        ],
    },
    {
        label: 'User',
        path: 'users',
        type: 'multiple',
        subLinks: [
            {
                label: 'All ',
                path: '/users/all',
            },
            {
                label: 'Active',
                path: '/users/active',
            },
            {
                label: 'Unverified',
                path: '/users/unverified',
            },
            {
                label: 'Deactivated',
                path: '/users/deactivate',
            },
        ],
    },
    {
        label: 'Wine Club',
        path: '/wineclub',
        type: 'single',
    },
    {
        label: 'Cron Updates',
        path: '/cron',
        type: 'single',
    },
    {
        label: 'Employee',
        path: 'employees',
        type: 'multiple',
        subLinks: [
            {
                label: 'All',
                path: '/employees/all',
            },
        ],
    },
    {
        label: 'Communications',
        path: 'communications',
        type: 'multiple',
        subLinks: [
            {
                label: 'Email Template',
                path: '/communications/email',
            },
            {
                label: 'SMS Template',
                path: '/communications/sms',
            },
        ],
    },
    {
        label: 'Logs',
        path: 'logs',
        type: 'multiple',
        subLinks: [
            {
                label: 'Email',
                path: '/logs/emailLogs',
            },
            {
                label: 'SMS',
                path: '/logs/smsLogs',
            },
            {
                label: 'Payment',
                path: '/logs/payment',
            },
        ],
    },
    // {
    //     label: 'Transactions',
    //     path: 'transaction',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Payment',
    //             path: '/transaction/payment',
    //         },
    //     ],
    // },
    {
        label: 'Invoice',
        path: 'invoice',
        type: 'multiple',
        subLinks: [
            {
                label: 'Unpaid',
                path: '/invoice/unpaid',
            },
            {
                label: 'Paid',
                path: '/invoice/paid',
            },
        ],
    },
    // {
    //     label: 'Wallet',
    //     path: '/wallet',
    //     type: 'single',
    // },
    // {
    //     label: 'Bid Deposit',
    //     path: '/bid_deposit',
    //     type: 'single',
    // },
    {
        label: 'Report',
        path: '/report',
        type: 'single',
    },
    // {
    //     label: 'Video Auction',
    //     path: 'videoAuction',
    //     type: 'multiple',
    //     subLinks: [
    //         {
    //             label: 'Broadcast',
    //             path: '/videoAuction/broadcast',
    //         },
    //         {
    //             label: 'Live Auctions',
    //             path: '/videoAuction/live_auction',
    //         },
    //     ],
    // },
    // {
    //     label: 'Language Manager',
    //     path: '/languageManager',
    //     type: 'single',
    // },
    {
        label: 'Settings',
        path: 'settings',
        type: 'multiple',
        subLinks: [
            {
                label: 'Static Pages',
                path: '/settings/static',
            },
            // {
            //     label: 'Category',
            //     path: '/settings/category',
            // },
            // {
            //     label: 'Condition',
            //     path: '/settings/condition',
            // },
            // {
            //     label: 'Location',
            //     path: '/settings/location',
            // },
            {
                label: 'Banner Image',
                path: '/settings/banner',
            },
            // {
            //     label: 'Business Category',
            //     path: '/settings/businesscategory',
            // },
            // {
            //     label: 'Vat',
            //     path: '/settings/vat',
            // },
            {
                label: 'General Settings',
                path: '/settings/general',
            },
            {
                label: 'Bid Increments',
                path: '/settings/bid_increments',
            },
            {
                label: 'Automation Testing',
                path: '/settings/automation_testing',
            },
        ],
    },
    {
        label: 'Change Password',
        path: '/change_password',
        type: 'single',
    },
]

export const ALL_PAGINATION = [
    {
        value: '20',
        show: '20 Results per page',
    },
    {
        value: '40',
        show: '40 Results per page',
    },
    {
        value: '60',
        show: '60 Results per page',
    },
]

export const HEADER_SIDE_PANEL = []
